var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6167 8.25H10.5667V11.3083L11.875 10C12.1167 9.75833 12.5167 9.75833 12.7583 10C13 10.2417 13 10.6417 12.7583 10.8833L10.3833 13.25C10.1417 13.4917 9.74166 13.4917 9.5 13.25L7.125 10.8833C7 10.7583 6.94166 10.6 6.94166 10.4417C6.94166 10.2833 7.00833 10.125 7.13333 10C7.375 9.75833 7.775 9.75833 8.01666 10L9.31666 11.3V8.25H2.38333C1.98333 8.25 1.66666 8.56667 1.66666 8.96667C1.66666 13.875 5.09166 17.3 10 17.3C14.9083 17.3 18.3333 13.875 18.3333 8.96667C18.3333 8.56667 18.0167 8.25 17.6167 8.25Z",
    fill: "#B5B9C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5667 3.3252C10.5667 2.98353 10.2833 2.7002 9.94167 2.7002C9.6 2.7002 9.31667 2.98353 9.31667 3.3252V8.24186H10.5667V3.3252Z",
    fill: "#B5B9C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.2db269109b58c1b4a425d604e47ab21e.svg";
export { ForwardRef as ReactComponent };